
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AuiFooter } from '@avalara/skylab-sdk/react';

class Footer extends Component {
  render() {
    const enableGlobalSupportTab = this.props.featureFlags?.EnableGlobalSupportTab;;

    const footerProps = {
      user: this.props.user || { isLoggedIn: false },
      termsUrl: "https://legal.avalara.com/",
    };

    return (
      <div className={enableGlobalSupportTab ? "hide-contact-button" : ""}>
        <AuiFooter 
          {...footerProps}
          data-testid={enableGlobalSupportTab ? "no_help_footer" : "help_footer"}
        />
      </div>
    );

  }
}

function mapStateToProps(state) {
  return {
    featureFlags: state.featureFlag && state.featureFlag.data,
    user: state.authentication && state.authentication.data
  };
}

export default connect(mapStateToProps)(Footer);